import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import useSeo from "@/lib/useSeo";

export default function NotFound() {
  useSeo({
    title: "Sayfa Bulunamadı | Epersonel",
    description:
      "Aradığınız sayfa taşınmış veya artık mevcut olmayabilir. Ana sayfaya dönerek Epersonel çözümlerini incelemeye devam edebilirsiniz.",
  });
  return (
    <section className="min-h-[60vh] grid place-items-center py-24">
      <div className="ep-container max-w-2xl text-center">
        <div className="font-display text-7xl md:text-8xl font-extrabold text-[#00F22E]">
          404
        </div>
        <h1 className="mt-4 font-display text-3xl md:text-4xl font-extrabold tracking-tight">
          Sayfa Bulunamadı
        </h1>
        <p className="mt-4 text-muted leading-relaxed">
          Aradığınız sayfa taşınmış veya artık mevcut olmayabilir. Ana sayfaya
          dönerek Epersonel çözümlerini incelemeye devam edebilirsiniz.
        </p>
        <Link
          to="/"
          className="btn-primary mt-8"
          data-testid="notfound-home-cta"
        >
          <HomeIcon className="h-4 w-4" /> Ana Sayfaya Dön
        </Link>
      </div>
    </section>
  );
}
